import {
    DataTable,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
    TableToolbarContent,
    TableToolbarSearch,
    TableToolbar,
    TableBatchActions,
    TableBatchAction,
    TableSelectAll,
    TableSelectRow
} from "carbon-components-react"
import { Save16 } from "@carbon/icons-react"
import _ from "lodash"
import { useEffect, useState } from "react"
import { getSpeakers } from "api/functions/functions"
import Button from "ui/Button"
import { consoleLog } from "utils/functions"

const SpeakerBioTable = (props) => {

    const [rowData, setRowData] = useState([])

    const [selected, setSelected] = useState([]);
    const [originalSelected, setOriginalSelected] = useState([]);

    const [shouldShowBatchActions, setShouldShowBatchActions] = useState(false);
    // const [selectedItem, setSelectedItem] = useState(null);
    const [itemsList, setItemsList] = useState([]);
    const [headerData, setHeaderData] = useState([
        {
            key: 'firstname',
            header: 'firstname',
        },
        {
            key: 'lastname',
            header: 'lastname',
        },

    ])

    useEffect(() => {
        if (!_.isEmpty(props.value)) {
            setSelected(props.value)
            // setOriginalSelected(props.value)
            // setSelectedItem(props.data)
        }
        // if (!init) {
        setOriginalSelected(props.value)
        if (props.value) {
            loadSpeakers(props.value)
        }
        // setInit(true)
        // }
    }, [])

    useEffect(() => {
        if (!_.isEmpty(props.value) && _.isEmpty(originalSelected)) {
            setOriginalSelected(props.value)
            // setSelectedItem(props.data)
        }
    }, [props.value])

    useEffect(() => {
        computeRowData(itemsList)
    }, [selected])

    const loadSpeakers = async (selectedItems, searchString) => {
        consoleLog("loadSpeakers", selectedItems, searchString)

        let speakers = props.speakers
        if (selectedItems || searchString) {
            let queryParams = {}
            if (selectedItems) {
                queryParams = {
                    ...queryParams,
                    ids: selectedItems
                }
            }
            if (searchString) {
                queryParams = {
                    ...queryParams,
                    q: searchString
                }
            }
            const res = await getSpeakers(queryParams, true)
            // if (!_.isEmpty(res.data)) {
            speakers = res.data
            setItemsList(speakers)
            props.onLoadSpeakers(speakers)
            // setRowData(res.data.map(item => {
            //     return {
            //         ...item,
            //         isSelected: item.id === selected,
            //     }
            // }))
            computeRowData(speakers, selectedItems)
            // }
        }
        else {
            setItemsList(speakers)
            computeRowData(speakers, selectedItems)
        }
    }

    const search = (e) => {
        if (e.target.value?.length > 2) {
            loadSpeakers([], e.target.value)
        }
        else if (e.target.value?.length === 0) {
            loadSpeakers(props.value)
        }
    }

    const computeRowData = (items, selectedItems) => {
        if (!selectedItems) {
            selectedItems = selected || []
        }
        setRowData(sortSelectedFirst(items).map(item => {
            return {
                ...item,
                isSelected: selectedItems.includes(item.id)
            }
        }))
    }


    const sortSelectedFirst = (items) => {
        let result = []
        if (!items) {
            items = itemsList
        }
        consoleLog("sortSelectedFirst", originalSelected, items, props.value)
        if (props.value) {
            props.value.forEach(function (key) {
                var found = false;
                items = items.filter(function (item) {
                    if (!found && item.id === key) {
                        result.push(item);
                        found = true;
                        return false;
                    } else
                        return true;
                })

            })
        }
        result = result.concat(items)
        return result
    }

    const openFormAddNew = () => {
        props.onOpenAddNew()
    }

    const toggleRow = (value) => {
        let newSelected = [...selected]

        if (selected.includes(value)) {
            newSelected = newSelected.filter(item => item !== value)
        }
        else {
            newSelected.push(value)
        }
        if (newSelected.length > 0) {
            setShouldShowBatchActions(true)
        }
        consoleLog("toggleRow", newSelected)
        setSelected(newSelected)
        // let newValue = null
        // let newValueId = null

        // if (!_.isEmpty(value)) {
        //     if (value.id !== selected) {
        //         newValue = value
        //         newValueId = value.id
        //     }
        // }
        // setSelected(value)
        // setSelectedItem(newValue)
    };

    const confirmChoice = () => {
        // let selectedItems = []
        // itemsList.forEach(item => {
        //     if (selected.includes(item.id)) {
        //         selectedItems.push(item)
        //     }
        // })
        consoleLog("confirmChoice", selected)
        setShouldShowBatchActions(false)
        props.onChange(selected);
    }

    const onBatchActionsCancel = () => {
        setSelected(originalSelected)
        setShouldShowBatchActions(false)
    }

    return (
        <DataTable rows={rowData} headers={headerData} stickyHeader={true}>
            {({
                rows,
                headers,
                getHeaderProps,
                getRowProps,
                getSelectionProps,
                getBatchActionProps,
                onInputChange,
                selectedRows,
            }) => {
                const selectAll = (props.allowSelectAll) ? (
                    <TableSelectAll {...getSelectionProps()} />
                ) : (
                    <TableHeader />
                )
                return (
                    <TableContainer className="speaker-bio__table">
                        <TableToolbar>
                            <TableBatchActions
                                {...getBatchActionProps()}
                                totalSelected={selectedRows.length}
                                onCancel={onBatchActionsCancel}
                                shouldShowBatchActions={shouldShowBatchActions}>
                                {/* <TableBatchAction
                                    tabIndex={getBatchActionProps().shouldShowBatchActions ? 0 : -1}
                                    renderIcon={TrashCan16}
                                    onClick={() => console.log('clicked')}
                                >
                                    Delete
                                </TableBatchAction> */}
                                <TableBatchAction
                                    tabIndex={getBatchActionProps().shouldShowBatchActions ? 0 : -1}
                                    renderIcon={Save16}
                                    onClick={() => confirmChoice()}
                                >
                                    Save
                                </TableBatchAction>
                                {/* <TableBatchAction
                                    tabIndex={getBatchActionProps().shouldShowBatchActions ? 0 : -1}
                                    renderIcon={CloudDownload16}
                                    onClick={() => console.log('clicked')}
                                >
                                    Download
                                </TableBatchAction> */}
                            </TableBatchActions>
                            <TableToolbarContent>
                                <TableToolbarSearch
                                    tabIndex={getBatchActionProps().shouldShowBatchActions ? -1 : 0}
                                    onChange={search}
                                    expanded={true}
                                    placeHolderText="Start typing to load speakers"
                                />
                                {/* <TableToolbarMenu
                                    tabIndex={getBatchActionProps().shouldShowBatchActions ? -1 : 0}
                                >
                                    <TableToolbarAction primaryFocus onClick={() => alert('Alert 1')}>
                                        Action 1
                </TableToolbarAction>
                                    <TableToolbarAction onClick={() => alert('Alert 2')}>
                                        Action 2
                </TableToolbarAction>
                                    <TableToolbarAction onClick={() => alert('Alert 3')}>
                                        Action 3
                </TableToolbarAction>
                                </TableToolbarMenu> */}
                                <Button
                                    tabIndex={getBatchActionProps().shouldShowBatchActions ? -1 : 0}
                                    onClick={() => openFormAddNew()}
                                    size="small"
                                    kind="primary"
                                >
                                    Add new
                                </Button>
                                <Button
                                    tabIndex={getBatchActionProps().shouldShowBatchActions ? -1 : 0}
                                    onClick={() => props.onClose()}
                                    size="small"
                                    kind="danger"
                                >
                                    Close
                                </Button>
                            </TableToolbarContent>
                        </TableToolbar>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {selectAll}
                                    {headers.map((header) => (
                                        <TableHeader {...getHeaderProps({ header })}>
                                            {header.header}
                                        </TableHeader>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(_.isEmpty(rows) || rows === undefined) ? null : rows.map((row) => {
                                    return (
                                        <TableRow {...getRowProps({ row })}>
                                            <TableSelectRow
                                                {...getSelectionProps({ row })}
                                                onChange={() => toggleRow(row.id)}
                                                checked={row.isSelected}
                                            />
                                            {row.cells.map((cell) => (
                                                <TableCell key={cell.id}>{cell.value}</TableCell>
                                            ))}
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )
            }}
        </DataTable>
    )
}

export default SpeakerBioTable